"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginStatus = void 0;
var LoginStatus;
(function (LoginStatus) {
    LoginStatus["Connected"] = "connected";
    LoginStatus["NotAuthorized"] = "not_authorized";
    LoginStatus["Unknown"] = "unknown";
})(LoginStatus = exports.LoginStatus || (exports.LoginStatus = {}));
